import { render } from "./oncrewSalesNet.vue?vue&type=template&id=b328c1a4&lang=true"
import script from "./oncrewSalesNet.vue?vue&type=script&lang=js"
export * from "./oncrewSalesNet.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__